import { LayoutDashboard, Package, TrendingUp, Settings, ShieldCheck, FileText, BarChart3 } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { Badge } from "@/components/ui/badge";

interface BrandSidebarProps {
  brandName?: string;
}

const menuItems = [
  { id: "dashboard", title: "Dashboard", icon: LayoutDashboard, path: "/brand/dashboard" },
  { id: "listings", title: "My Listings", icon: Package, path: "/brand/listings" },
  { id: "orders", title: "Orders", icon: FileText, path: "/brand/orders" },
  { id: "analytics", title: "Analytics", icon: BarChart3, path: "/brand/analytics" },
  { id: "inventory", title: "Inventory", icon: Package, path: "/brand/inventory" },
  { id: "settings", title: "Settings", icon: Settings, path: "/brand/settings" },
];

export function BrandSidebar({ brandName }: BrandSidebarProps) {
  const { open } = useSidebar();
  const location = useLocation();

  return (
    <Sidebar className={open ? "w-60" : "w-14"}>
      <div className="p-4 border-b flex items-center gap-2">
        <ShieldCheck className="h-5 w-5 text-primary" />
        {open && (
          <div className="flex-1">
            <h2 className="font-semibold text-sm">{brandName || "Brand Portal"}</h2>
            <Badge variant="secondary" className="text-xs">Official</Badge>
          </div>
        )}
      </div>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Brand Management</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.id}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) => 
                        isActive ? "bg-muted text-primary font-medium" : ""
                      }
                    >
                      <item.icon className="h-4 w-4" />
                      {open && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}